import React, { useEffect, useMemo, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import { ConsultaTotvsEmpresa, ConsultaTotvsEmpresaIndividual } from "../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import SelectFixo from "../../../components/SelectFixo";

import Cotacao from "../../../../lib/json/consultas/Cotacao.json"
import SelectEmpresa from "../../../components/Select/Empresa";
import SelectCentroCusto from "../../../components/Select/CentroCusto";
import SelectComprador from "../../../components/Select/Comprador";
import { ErroMsg, RetornaUsuarioLogado, SucessoMsg, encryptAES, formatDateColumn, formatarComoMoeda } from "../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { format, startOfMonth, startOfYear } from "date-fns";
import { usePopUp } from "../../../components/BootBox";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { useSessionStorageState } from "../../../../hooks/useSessionStorageState";
import ExportarExcel from "../../../components/ExportarExcel";

function handleCompradorCotacaoColumn(item){
    const result = item.value + " - " + item.row.original.Y1_NOME
    return result
}

function handleStatusCotacaoColumn(item){
    const options = [        
        {
            value: '01',
            text: "Em Aberto",
        },
        {
            value: '02',
            text: "Parcialmente Encerrada",
        },
        {
            value: '03',
            text: "Finalizada",
        }
    ];

    const result = options.filter((opt) => opt.value === item.value)[0].text
    
    return result
}


function ListaCotacao(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = Cotacao.tabelas;
    
    const navigate = useNavigate();
    const currentDate = new Date()
    const firstDayOfMonthDate = startOfMonth(currentDate);
    const usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus
    
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useSessionStorageState("cotacaoEmpresa", {value: "",text: "", });
    const [cotacao, setCotacao] = useSessionStorageState("cotacaoCotacao",'');
    const [solicitacao, setSolicitacao] = useSessionStorageState("cotacaoSolicitacao",'');
    const [dateDe, setDateDe] =  useSessionStorageState("cotacaoDateDe",format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useSessionStorageState("cotacaoDateAte",format(currentDate, 'yyyy-MM-dd'));
    const [campoComprador, setCampoComprador] = useSessionStorageState("cotacaoCampoComprador",{value: usuarioProtheus?.value || '', label: ''});
    const [campoCentroCusto, setCampoCentroCusto] = useSessionStorageState("cotacaoCampoCentroCusto",null);
    const [campoStatus, setCampoStatus] = useSessionStorageState("cotacaoCampoStatus", {value: '00', text: 'Todos'});
    const [disabledComprador, setDisabledComprador] = useState(!usuarioLogado.permissao.visualizarPedidoCompra)    


    var empresaCopiar = {value: '', text: ''};
    var scOrigem = '';
    var empresaOrigem = '';
    
    const excelColumns = [
        {
            Header: 'Filial',
            accessor: "C8_FILIAL",
        },
        {
            Header: 'Cotação',
            accessor: "C8_NUM"
        },
        {
            Header: 'Data Emissão',
            accessor: 'C8_EMISSAO',
            Cell: formatDateColumn
        },
        {
            Header: 'Data Prazo Final',
            accessor: 'C8_VALIDA',
            Cell: formatDateColumn
        },
        {
            Header: 'Hora Prazo Final',
            accessor: 'C8_XVALIDA'
        },
        {
          Header: 'Comprador',
          accessor: "Y1_COD",          
        },
        {
          Header: 'Nome Comprador',
          accessor: "Y1_NOME",          
        },
        {
          Header: 'Status',
          accessor: 'STATUS'
        },
        {
          Header: 'Qtd. Forn.',
          accessor: 'FORNECEDORES'
        },
        {
          Header: 'Qtd. Resp.',
          accessor: 'RESPONDIDO'
        }
    ]

    // Colunas do grid
    const columns = [
        {
          Header: 'Filial',
          accessor: "C8_FILIAL",
        },
        {
          Header: 'Cotação',
          accessor: "C8_NUM"
        },
        {
          Header: 'Emissão',
          accessor: 'C8_EMISSAO',
          Cell: formatDateColumn
        },
        {
          Header: 'Prazo Final',
          accessor: 'C8_VALIDA',
          Cell: formatDateColumn
        },
        {
          Header: 'Prazo Final',
          accessor: 'C8_XVALIDA'
        },
        {
          Header: 'Comprador',
          accessor: "Y1_COD",
          Cell: handleCompradorCotacaoColumn
        },
        {
          Header: 'Status',
          accessor: 'STATUS'
        },
        {
          Header: 'Qtd. Forn.',
          accessor: 'FORNECEDORES'
        },
        {
          Header: 'Qtd. Resp.',
          accessor: 'RESPONDIDO'
        }
    ];

    // WHERE/filtros da consulta do grid
    const retornaConsultaDefault = () => {
        let camposAdicionais = ", (SELECT COUNT(*) FROM TABELA(SC8) C8A WHERE C8A.C8_FILIAL = SC8.C8_FILIAL AND C8A.C8_NUM = SC8.C8_NUM AND C8A.D_E_L_E_T_ <> '*' AND C8A.C8_NUMPED != '' ) PEDCONGERADO "
        camposAdicionais += ", (SELECT COUNT(*) FROM TABELA(SC8) C8A WHERE C8A.C8_FILIAL = SC8.C8_FILIAL AND C8A.C8_NUM = SC8.C8_NUM AND C8A.D_E_L_E_T_ <> '*' AND C8A.C8_NUMPED = '' ) ABERTO "
        camposAdicionais += ", (SELECT COUNT(DISTINCT C8_FORNECE + C8_LOJA) FROM TABELA(SC8) C8A WHERE C8A.C8_FILIAL = SC8.C8_FILIAL AND C8A.C8_NUM = SC8.C8_NUM AND C8A.D_E_L_E_T_ <> '*' ) FORNECEDORES "
        camposAdicionais += ", (SELECT COUNT(DISTINCT C8_FORNECE + C8_LOJA) FROM TABELA(SC8) C8A WHERE C8A.C8_FILIAL = SC8.C8_FILIAL AND C8A.C8_NUM = SC8.C8_NUM AND C8A.D_E_L_E_T_ <> '*' AND C8A.C8_XMPRESP = 'S' ) RESPONDIDO " 
		camposAdicionais += ", COALESCE((SELECT COUNT(*) FROM TABELA(SC1) C1A INNER JOIN TABELA(SC8) C8A ON C1A.C1_FILIAL = C8A.C8_FILIAL AND C1A.C1_NUM = C8A.C8_NUMSC AND C1A.C1_ITEM = C8A.C8_ITEMSC AND C1A.C1_XFLUXSC = '3' AND C1A.D_E_L_E_T_ <> '*' WHERE C8A.C8_FILIAL = SC8.C8_FILIAL AND C8A.C8_NUM = SC8.C8_NUM AND C8A.D_E_L_E_T_ <> '*' ),0) EMERGENCIAL " 

        var consultaDefault = Cotacao.consulta.replace('[CAMPOS]', camposAdicionais);
        
        consultaDefault += "AND C8_FILIAL = FILIAL(SC8) ";
        
        if(cotacao) {
            consultaDefault += "AND C8_NUM = '"+cotacao+"' ";
        }
        if(dateDe) {
            consultaDefault += "AND C8_EMISSAO >= '"+dateDe.replaceAll('-','')+"' ";
        }
        if(dateAte) {
            consultaDefault += "AND C8_EMISSAO <= '"+dateAte.replaceAll('-','')+"' ";
        }
        if(campoComprador && campoComprador.value) {
            consultaDefault += "AND Y1_USER = '"+campoComprador.value+"' ";
        }
        if(campoCentroCusto && campoCentroCusto.value) {
            consultaDefault += "AND C8_FILIAL + C8_NUM IN (SELECT DISTINCT C8A.C8_FILIAL + C8A.C8_NUM FROM TABELA(SC8) C8A INNER JOIN TABELA(SC1) C1A ON C1A.C1_FILIAL = C8A.C8_FILIAL AND C1A.C1_NUM = C8A.C8_NUMSC AND C1A.C1_ITEM = C8A.C8_ITEMSC AND C1A.D_E_L_E_T_ <> '*' WHERE C8A.D_E_L_E_T_ <> '*' AND C8A.C8_FILIAL = FILIAL(SC8) AND C1A.C1_CC = '"+campoCentroCusto.value+"')  ";
        }
        if(solicitacao) {
            consultaDefault += "AND C8_FILIAL + C8_NUM IN (SELECT DISTINCT C8A.C8_FILIAL + C8A.C8_NUM FROM TABELA(SC8) C8A WHERE C8A.D_E_L_E_T_ <> '*' AND C8A.C8_FILIAL = FILIAL(SC8) AND C8A.C8_NUMSC = '"+solicitacao+"')  ";
        }
        
        consultaDefault += 'GROUP BY C8_FILIAL, C8_NUM, Y1_COD, Y1_NOME, Y1_USER, Y1_EMAIL, C8_EMISSAO, C8_VALIDA, C8_XVALIDA '
        consultaDefault += 'ORDER BY C8_FILIAL, C8_NUM'
        return consultaDefault
    }

    // Processa consulta do grid
    const listaCotacao = async () => {
        var consultaDefault = retornaConsultaDefault();
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, empresaFilial );
        
        if (retConsulta.error === '00'){
            let dataAux = retConsulta.data.map( (item) => {
                let status = "Indefinido";
                let statusCode = "01";

                if (parseFloat(item.ABERTO) > 0 && parseFloat(item.PEDCONGERADO) > 0) {
                    statusCode = "02"
                    status = "Parcialmente Encerrada";
                } else if (parseFloat(item.ABERTO) > 0 && parseFloat(item.PEDCONGERADO) === 0) {
                    statusCode = "01"
                    status = "Em Aberto";
                } else if (parseFloat(item.ABERTO) === 0 && parseFloat(item.PEDCONGERADO) > 0) {
                    statusCode = "03"
                    status = "Finalizada";
                }

                item.C8_STATUS = statusCode
                item.STATUS = status       
                
                return item
            })

            if (campoStatus.value.trim()){
                if (campoStatus.value === '04'){
                    dataAux = dataAux.filter( (item) => item.C8_STATUS === '01' || item.C8_STATUS === '02');
                }else if (campoStatus.value !== '00'){
                    dataAux = dataAux.filter( (item) => item.C8_STATUS === campoStatus.value);
                }
            }

            setData(dataAux);
        } 

        setCarregar(false);
    }

    useEffect( () => {
        listaCotacao()
    },[])

    const options = [
        {
            value: '00',
            text: "Todos",
        },
        {
            value: '04',
            text: "Pendente",
        },
        {
            value: '01',
            text: "Em Aberto",
        },
        {
            value: '02',
            text: "Parcialmente Encerrada",
        },
        {
            value: '03',
            text: "Finalizada",
        }
    ];

    const handleMapa = (row) =>{
        const secretKey = window._env_?.REACT_APP_KEY_COTACAO
        const dadosCotacao = JSON.stringify({
            Filial: `${row.original.EMPRESA}${row.original.C8_FILIAL}`,
            Numero: row.values.C8_NUM,
            Homologado: true
        });

        const encryptedText = encryptAES(dadosCotacao, secretKey);
        navigate(`./Mapa/Comparativo/${encryptedText}`)
    }

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.C8_NUM}/${row.original.EMPRESA}${row.original.C8_FILIAL}`)
    }
    
    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.values.C8_NUM}/${row.original.EMPRESA}${row.original.C8_FILIAL}`)
    }
    
     const handleExcluir = async (row) => {
        const idRow = row.original.EMPRESA + '' + row.original.C8_FILIAL + '|' + row.original.C8_NUM;
        const Mensagem = `Tem certeza que deseja excluir a Cotação ${row.original.C8_NUM + ' - da Filial: ' + row.original.C8_FILIAL}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { Numero: row.split('|')[1] }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('EXCLUIRCOTACAO', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
            listaCotacao();
        }
    };

    const excelHeaders = useMemo(() => {
        return excelColumns.map(col => col.Header);
    }, [excelColumns]);

    const excelRows = useMemo(() => {
        return data.map(item =>
            excelColumns.map(col => {
                const value = item[col.accessor];

                if (col.Cell) {
                    return col.Cell({ value, row: { original: item } });
                }
                return value ?? ""; // valor padrão se undefined/null
            })
        );
    }, [data, excelColumns]);

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Cotação"/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Cotação"
                        tipo='text'
                        max="6"
                        value={cotacao}  // Define o valor do campo com base no estado
                        onChange={(e) => setCotacao(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Solicitação"
                        tipo='text'
                        max="6"
                        value={solicitacao}  // Define o valor do campo com base no estado
                        onChange={(e) => setSolicitacao(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão de"
                        tipo='date'
                        value={dateDe}
                        onChange={(e) => setDateDe(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão até"
                        tipo='date'
                        value={dateAte}
                        onChange={(e) => setDateAte(e.target.value)}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectComprador
                        campoComprador={campoComprador}
                        changeComprador={setCampoComprador}
                        empresaLogada={empresa.value}
                        disabled={disabledComprador}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectCentroCusto 
                        campoCentroCusto={campoCentroCusto}
                        changeCentroCusto={setCampoCentroCusto}
                        empresaLogada={empresa.value}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectFixo 
                        options={options} 
                        value={campoStatus} 
                        multiple={false}
                        selectedOptionValue={campoStatus}
                        isLabel={true} 
                        label="Status" 
                        onChange={(e) => setCampoStatus(e)}
                    />
                </Col>
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaCotacao}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
                <Col md="3" xs="12">
                    <ExportarExcel 
                        nomeArquivo="Cotacoes"
                        headers={excelHeaders}
                        rows={excelRows}
                    />
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        linhaCondicional={(item) => item.EMERGENCIAL != 0}
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote", 
                                regraExclude: "!('01;02'.includes(row.original.C8_STATUS) ) "
                            }, 
                            // {isAlterar: true, action: handleCopiar, label: "Copiar", icone: "MdOutlineCopyAll", style: "success"}, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger", 
                                regraExclude: "(row.original.C8_STATUS !== '01' ) "
                            },
                            {isAlterar: true, action: handleMapa, label: "Mapa Comparativo", icone: "MdOutlineAnalytics", style: "secondary"}
                        ]}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaCotacao;